import { Entity, Field } from 'typegraph';

export default class GroupDiscountData {
    
    @Field()
    public min: number;
    
    @Field()
    public max: number;
    
    @Field()
	public cost: number;

}


// WEBPACK FOOTER //
// ./src/panels/bundleEntries/entities/GroupDiscountData.ts